(function() {
  "use strict";

  if (!customElements.get("store-locator")) {
    customElements.define("store-locator", class extends HTMLElement {
      connectedCallback() {
        this.tabs = this.querySelectorAll("[data-tab-city]");
        this.cards = this.querySelectorAll("[data-store-card]");
        this.listContainer = this.querySelector("[data-store-list]");

        this.tabs.forEach(tab => {
          tab.addEventListener("click", () => {
            const selectedCity = tab.getAttribute("data-tab-city");
            this.setActiveCity(selectedCity);
          });
        });

        // Initialize with the first active city
        const activeTab = this.querySelector("[data-tab-city].active");
        if (activeTab) {
          this.setActiveCity(activeTab.getAttribute("data-tab-city"));
        } else if (this.tabs.length > 0) {
          this.setActiveCity(this.tabs[0].getAttribute("data-tab-city"));
        }
      }

      setActiveCity(city) {
        this.tabs.forEach(tab => {
          if (tab.getAttribute("data-tab-city") === city) {
            tab.classList.add("active");
            tab.setAttribute("aria-selected", "true");
          } else {
            tab.classList.remove("active");
            tab.setAttribute("aria-selected", "false");
          }
        });

        this.cards.forEach(card => {
          if (card.getAttribute("data-card-city") === city) {
            card.style.display = "block";
            setTimeout(() => {
              card.classList.add("fade-in");
            }, 10);
          } else {
            card.style.display = "none";
            card.classList.remove("fade-in");
          }
        });

        if (this.listContainer) {
          this.listContainer.scrollTop = 0;
        }
      }
    });
  }
})();
